import React from 'react';
import './CancelTransactionPopup.css';

const CancelTransactionPopup = ({ isOpen, onConfirm, onCancel, isProcessing, message }) => {
  if (!isOpen) return null;

  return (
    <div className="cancel-transaction-overlay" onClick={!isProcessing ? onCancel : undefined}>
      <div className="cancel-transaction-popup" onClick={(e) => e.stopPropagation()}>
        {/* Warning Icon */}
        <div className="cancel-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
          </svg>
        </div>

        {/* Title */}
        <h2 className="cancel-title">{message?.title || "Cancel Current Transaction?"}</h2>
        <p className="cancel-message">
          {message?.text || "Do you really want to cancel current transaction? This will reset your booking and you'll need to select seats again."}
        </p>

        {/* Action Buttons */}
        <div className="cancel-actions">
          <button 
            className="cancel-btn-secondary" 
            onClick={onCancel}
            disabled={isProcessing}
          >
            No, Continue
          </button>
          <button 
            className="cancel-btn-primary" 
            onClick={onConfirm}
            disabled={isProcessing}
          >
            {isProcessing ? 'Processing...' : 'Yes, Cancel'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelTransactionPopup;

